export enum ProjectTabs {
  PROJECT = 'o-pribehu',
  DONORS = 'darci',
  SUBPROJECT = 'dobrovyzva',
  FAQS = 'faq',
  NEWS = 'aktuality',
}
